import script from "./ClassGrade.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassGrade.vue?vue&type=script&setup=true&lang=ts"

import "./ClassGrade.vue?vue&type=style&index=0&id=5d29965d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d29965d"]])

export default __exports__